module.exports = __webpack_public_path__ + "img/img0.650954ef.jpg";